// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head__1TumP","head_crumbs":"index_head_crumbs__zNiFv","head_line":"index_head_line__3kTwK","content":"index_content__1RIqz"};